import React, { Component } from 'react';
import { FormGroup, Input, Button, Modal, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import CounterInput from '../../components/reusable/CounterInput';
import c from '../../constants/Colors';
import { setLocal, ListarLocal } from '../../store/sagas/perfilApi';
import localStorageCustom from '../../utilitarios/localStorage';
import { notificacion } from '../../utilitarios/util';
import { AuthContext } from "../../store/provider/AuthProvider";
import Spinner from "../reusable/Loader";

const ModalEdit = ({ dadComponent }) => {
  let visible = dadComponent.state.modalEdit;
  let local = dadComponent.state.local;
  let alias = dadComponent.state.alias;
  return (
    <Modal isOpen={visible} toggle={() => { dadComponent.ShowModalEdit(local) }} className="modal_edit" centered>
      <button className="btn-icon modal-close" onClick={() => { dadComponent.ShowModalEdit(local) }}><SvgAssets icon="icon-close" fill={c.azulClaro} /></button>
      <h6 className="paragraph-2 bold" style={{ color: c.azulClaro }}>{local.direccion}</h6>
      <FormGroup>
        <Input type='text' name="alias" placeholder="Alias" 
            value={alias}
            onChange={(alias) => dadComponent.setAlias(alias)}
            />
      </FormGroup>
      <div className="text-center">
        <button className='btn-block mt-0' 
        type="button"
        onClick={() => {
          dadComponent.ActualizaLocal()
        }}
        style={{ backgroundColor: c.verdeClaro }}>Actualizar</button>
      </div>
    </Modal>
  );
}

export class Locales extends Component {
  static displayName = Locales.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      modalEdit: false,
      loading: true,
      locales: [],
      localesFiltrados: [],
      local: {},
      alias: null,
      search: '',
      asociado: {}
    };
    // this.toggleModal = this.toggleModal.bind(this);
  }

  setAlias = (e) => {
    let value = e.currentTarget.value;
    this.setState({ alias: value, errorValidacion: null })
  }

  searchLocal = (e) => {
    let text = e.currentTarget.value;
    this.setState({ loading: true });
    if (text) {
      let textData = text.toUpperCase();

      let newData = this.state.locales.filter(function (item) {
        const itemData = item.alias ? item.alias.toUpperCase() : ''.toUpperCase();
        const itemDireccion = item.direccion ? item.direccion.toUpperCase() : ''.toUpperCase();
        const itemReferencia1 = item.referencia1 ? item.referencia1.toUpperCase() : ''.toUpperCase();
        const itemReferencia2 = item.referencia2 ? item.referencia2.toUpperCase() : ''.toUpperCase();

        if (itemData.indexOf(textData) > -1) return item;
        if (itemDireccion.indexOf(textData) > -1) return item;
        if (itemReferencia1.indexOf(textData) > -1) return item;
        if (itemReferencia2.indexOf(textData) > -1) return item;

      });

      this.setState({ localesFiltrados: newData, search: text, loading: false });
    } else {
      this.setState({ localesFiltrados: this.state.locales, search: '', loading: false });
    }
  }
  ActualizaLocal = () => {
    let storageGeneral = localStorageCustom.prototype.getUsuario();
    this.postLocal(storageGeneral.dealer.codcliente,
      storageGeneral.dealer.correoElectronico,
      this.state.alias, this.state.local.localId,
      storageGeneral.linea.canal, storageGeneral.linea.sector);
  }

  checkParams() {
    // const { state } = this.props.location;
    this.setState({
      // locales: params.locales,
      // localesFiltrados: params.locales,
      loading: false
    });
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.checkParams();
    let data = localStorageCustom.prototype.getUsuario();
    this.setState({
      asociado: data.asociado
    }, () => {
      this.postListarLocal(data.dealer.codcliente, data.dealer.correoElectronico,
        data.linea.canal, data.linea.sector);
    })
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  render() {
    const { modalEdit, localesFiltrados, asociado, loading } = this.state;
    console.log(localesFiltrados);
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="rs_container desktop">
          <button className='btn-icon back mobile'>
            <SvgAssets icon="icon-arrow-left" fill={c.azulClaro} />
          </button>
          <SvgAssets className="icon" icon="icon-user" fill={c.rojoClaro} />
          <h6 className="title-2">{asociado.razonsSocial}</h6>
          <p className="paragraph-1 azul">Repuestos</p>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li><Link to='/perfil'>Mi Perfil</Link></li>
              <li><Link to='/locales' style={{ pointerEvents: 'none' }}>Locales</Link></li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <h6 className="title white mobile"><Link to='/perfil' className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></Link><SvgAssets icon="icon-local" fill="#fff" />Locales</h6>
          <div className="card container_1080">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
            <div className="content_locales">
              <h6 className="title desktop"><SvgAssets icon="icon-local" fill={c.azulClaro} />Locales</h6>
              <FormGroup className="icon mb-5">
                <Input className=""
                  type='text'
                  placeholder="Dirección o Alias"
                  onChange={(text) => this.searchLocal(text)} />
                <Button color="link" className="btn-icon">
                  <SvgAssets icon='icon-lupa' fill={c.azulClaro} />
                </Button>
              </FormGroup>
            </div>
            {localesFiltrados.map((data, index) => {
              return (
                <div className="card_product_horizontal card_local" key={index}>
                  <div className="cphCounterInput" style={{ backgroundColor: c.verdeClaro }}>
                    <button className="btn-icon"
                      onClick={() => { this.ShowModalEdit(data) }}>
                      <SvgAssets icon="icon-edit" fill="#fff" />
                    </button>
                  </div>
                  {(data.alias == null || data.alias == "") ?
                    <div className="cphTextCenter">
                      
                      <span className="paragraph-3 light"><SvgAssets icon="icon-local" fill={c.azulClaro} className="mr-1" />{data.direccion}</span>                    
                    </div>
                    :
                    <div className="cphTextCenter">
                      <span className="paragraph-3 light">{data.direccion}</span>
                      <h6 className="paragraph-2 bold mb-0" style={{ color: c.verdeClaro }}><SvgAssets icon="icon-local" fill={c.azulClaro} className="mr-1" />{data.alias}</h6>
                    </div>
                  }
                </div>
              )
            })}
            {/* <div className="card_product_horizontal">
              <div className="cphCounterInput" style={{ backgroundColor: c.verdeClaro }}>
                <button className="btn-icon" onClick={this.toggleModal}><SvgAssets icon="icon-edit" fill="#fff" /></button>
              </div>
              <div className="cphTextCenter">
                <span className="paragraph-3">Calle las begonias N° 2322</span>
                <h6 className="paragraph-2 bold mb-0" style={{ color: c.verdeClaro }}><SvgAssets icon="icon-local" fill={c.azulClaro} className="mr-1" />San Isidro - Begonias</h6>
              </div>
            </div>
            <div className="card_product_horizontal">
              <div className="cphCounterInput" style={{ backgroundColor: c.verdeClaro }}>
                <button className="btn-icon" onClick={this.toggleModal}><SvgAssets icon="icon-edit" fill="#fff" /></button>
              </div>
              <div className="cphTextCenter">
                <span className="paragraph-3">Calle las begonias N° 2322</span>
                <h6 className="paragraph-2 bold mb-0" style={{ color: c.verdeClaro }}><SvgAssets icon="icon-local" fill={c.azulClaro} className="mr-1" />San Isidro - Begonias</h6>
              </div>
            </div>
            <div className="card_product_horizontal">
              <div className="cphCounterInput" style={{ backgroundColor: c.verdeClaro }}>
                <button className="btn-icon" onClick={this.toggleModal}><SvgAssets icon="icon-edit" fill="#fff" /></button>
              </div>
              <div className="cphTextCenter">
                <h6 className="paragraph-2 bold mb-0" style={{ color: c.verdeClaro }}>
                  <SvgAssets icon="icon-local" fill={c.azulClaro} className="mr-1" />
                  Avenida Paseo de la república 3195
                </h6>
              </div>
            </div> */}
          </div>
        </Container>
        <ModalEdit dadComponent={this} />
      </div>
    );
  }

  postListarLocal = async (CodigoDealer, CorreoElectronico, Canal, Sector) => {
    this.setState({ loading: true });
    ListarLocal(CodigoDealer, CorreoElectronico, Canal, Sector)
      .then(result => {
        if (result.mo.type == "success") {


          this.setState({
            loading: false,
            alias: null,
            modalEdit: false,
            locales: result.dto.locales,
            localesFiltrados: result.dto.locales
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Perfil", error.message ?? null);
        });
      });

  }

  postLocal = async (CodigoDealer, CorreoElectronico, Alias, LocalId, Canal, Sector) => {
    this.setState({ loading: true });
    setLocal(CodigoDealer, CorreoElectronico, Alias, LocalId, Canal, Sector)
      .then(result => {
        if (result.mo.type == "success") {
          let _locales = result.dto.locales;
          let ids = this.state.localesFiltrados.map(x => x.localId);
          let newData = _locales.filter(f => ids.includes(f.localId));
          let _localesFiltrados = newData;
          this.setState({
            loading: false,
            alias: null,
            modalEdit: false,
            locales: _locales,
            localesFiltrados: _localesFiltrados
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Perfil", error.message ?? null);
        });
      });

  }

  ShowModalEdit = (data) => {
    console.log(this.state.modalEdit);
    this.setState(prevState => ({
      modalEdit: !prevState.modalEdit,
      local: data,
      alias: prevState.modalEdit ? '' : data.alias
    }));
  }
}
